import { useLayoutEffect, useRef, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router";

import step2Style from "./step2.module.css";
import Nav from "./nav";
import Loading from "consumer/setup/loading";
import Info from "./step2/info";
import List from "./step2/list";

import { get_academy_info } from "consumer/@@@/get_academy_info";
import { get_notice_list } from "consumer/@@@/get_notice_list";
import { get_grade_list } from "consumer/@@@/get_grade_list";
import { get_event_list } from "consumer/@@@/get_event_list";
import { SocketContext } from "context/SocketContext";

export default function Step2() {
	const location = useLocation();
	const branch_id = location.state.branch_id;

	const isMounted = useRef(0);

	const [academyInfo, Set_academyInfo] = useState({});
	const [gradeList, Set_gradeList] = useState([]);
	const [eventList, Set_eventList] = useState([]);
	const [noticeList, Set_noticeList] = useState([]);

	const [inProgressMap, setInProgressMap] = useState({});

	const [loading, Set_loading] = useState(true);

	const { socket } = useContext(SocketContext);

	// 학원 정보, 공지 목록, 학년 코드 목록을 가져옴
	useLayoutEffect(() => {
		if (branch_id && isMounted.current === 0) {
			get_academy_info({
				branch_id: branch_id,
				Set_academyInfo: Set_academyInfo,
			});
			get_notice_list({
				branch_id: branch_id,
				Set_noticeList: Set_noticeList,
			});
			get_grade_list({
				Set_gradeList: Set_gradeList,
				isMounted: isMounted,
			});
		}
	}, []);

	useLayoutEffect(() => {
		if (isMounted.current === 1) {
			get_event_list({
				branch_id: branch_id,
				Set_eventList: Set_eventList,
				isMounted: isMounted,
			});
		}
	}, [gradeList]);

	useLayoutEffect(() => {
		if (isMounted.current === 2) {
			Set_loading(false);
		}
	}, [eventList]);

	useEffect(() => {
		if (!socket || !branch_id) return;

		socket.emit("branch:join", { branchId: branch_id });
		// socket.emit("getData", branch_id);

		return () => {
			// (선택) 나갈 때 branch room leave를 서버에 구현했다면 호출
			// socket.emit("branch:leave", { branchId: branch_id });
		};
	}, [socket, branch_id]);

	// axios로 eventList 받은 뒤 → 현재 inProgress 동기화 요청
	useEffect(() => {
		if (!socket || eventList.length === 0) return;

		const scheduleIds = [];
		for (const ev of eventList) {
			for (const sch of ev.Schedules ?? []) {
				scheduleIds.push(sch.id);
			}
		}

		socket.emit("inProgress:sync", {
			branchId: branch_id,
			scheduleIds,
		});
	}, [socket, eventList, branch_id]);

	// 초기 동기화 값 수신
	useEffect(() => {
		if (!socket) return;

		const onMap = (map) => {
			setInProgressMap(map);
		};

		socket.on("inProgress:map", onMap);
		return () => socket.off("inProgress:map", onMap);
	}, [socket]);

	useEffect(() => {
		if (!socket) return;

		const onCount = ({ scheduleId, inProgress }) => {
			setInProgressMap((prev) => ({ ...prev, [scheduleId]: inProgress }));
		};

		socket.on("schedule:count", onCount);
		return () => socket.off("schedule:count", onCount);
	}, [socket]);

	const reloadEvent = (scheduleId) => {
		if (!socket) return;
		socket.emit("schedule:join", { scheduleId });
	};

	console.log(inProgressMap);

	return (
		<div id="step2" className={step2Style['step2']}>
			<Nav step={2}></Nav>

			<Loading loading={loading}></Loading>

			<Info academyInfo={academyInfo} noticeList={noticeList}></Info>

			<List
				academyInfo={academyInfo}
				gradeList={gradeList}
				eventList={eventList}
				inProgressMap={inProgressMap}
				reloadEvent={reloadEvent}
			></List>
		</div>
	);
}
